import { ValidatedToolNode as ValidatedToolSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { ValidatedToolNodeView } from '#src/components/rich-text-editor/ValidatedToolNode/ValidatedToolNodeView.tsx'

export const ValidatedToolNode = ValidatedToolSchema.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ValidatedToolNodeView, { className: 'group' })
  },
})
